import { render } from "./EditCoResidents.vue?vue&type=template&id=d89dac86&scoped=true"
import script from "./EditCoResidents.vue?vue&type=script&lang=js"
export * from "./EditCoResidents.vue?vue&type=script&lang=js"

import "./EditCoResidents.vue?vue&type=style&index=0&id=d89dac86&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89dac86"]])

export default __exports__